<template>
  <div
    class="modal fade"
    ref="modalTicketInfo"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ticketInfoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-5" id="ticketInfoModalLabel">
            Información de la solicitud
          </h5>
          <button class="btn-close" type="button" @click="hide"></button>
        </div>

        <div class="modal-body">
          <form v-if="ticket">
            <div class="row mb-3">
              <div class="col-md-6 col-12 mb-2">
                <label class="form-label fw-bold">Usuario</label>
                <input
                  type="text"
                  class="form-control"
                  :value="fullUserName(ticket.user)"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label class="form-label fw-bold">Documento</label>
                <input
                  type="text"
                  class="form-control"
                  :value="ticket.participant_document || '—'"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2" v-if="ticket.event">
                <label class="form-label fw-bold">Evento</label>
                <input
                  type="text"
                  class="form-control"
                  :value="ticket.event.title"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label class="form-label fw-bold">Tipo de acción</label>
                <input
                  type="text"
                  class="form-control"
                  :value="actionText(ticket.action)"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label class="form-label fw-bold">Estado</label>
                <input
                  type="text"
                  class="form-control"
                  :value="statusText(ticket.status)"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label class="form-label fw-bold">Tipo de usuario</label>
                <input
                  type="text"
                  class="form-control"
                  :value="ticket.user_type || '—'"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label class="form-label fw-bold">Creado</label>
                <input
                  type="text"
                  class="form-control"
                  :value="formatDate(ticket.created_at)"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label class="form-label fw-bold">Actualizado</label>
                <input
                  type="text"
                  class="form-control"
                  :value="formatDate(ticket.updated_at)"
                  disabled
                />
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">Detalle</label>
              <textarea
                class="form-control"
                :value="ticket.detail"
                rows="3"
                disabled
              ></textarea>
            </div>

            <div class="mb-3" v-if="ticket.comments">
              <label class="form-label fw-bold">Comentario</label>
              <textarea
                class="form-control text-muted"
                :value="ticket.comments"
                rows="2"
                disabled
              ></textarea>
            </div>
          </form>

          <div v-else class="text-center py-4">
            <i class="fa fa-spinner fa-spin fa-2x text-secondary"></i>
            <p class="mt-2">Cargando información...</p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hide">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Modal } from "bootstrap";

const ticket = ref(null);
const modalTicketInfo = ref(null);
let bootstrapModal = null;

function show(data) {
  ticket.value = data;
  bootstrapModal.show();
}

function hide() {
  bootstrapModal.hide();
  ticket.value = null;
}

function fullUserName(user) {
  if (!user) return "—";
  return `${user.name || ""} ${user.first_last_name || ""} ${
    user.second_last_name || ""
  }`.trim();
}

function formatDate(date) {
  if (!date) return "—";
  return new Date(date).toLocaleString("es-BO", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function statusText(status) {
  const map = {
    ACTIVO: "Activo",
    RESUELTO: "Resuelto",
    CANCELADO: "Cancelado",
  };
  return map[status] || status || "—";
}

function actionText(action) {
  const map = {
    COMPROBANTE: "Comprobante",
    CERTIFICADO: "Certificado",
    CONTRASEÑA: "Restablecer Contraseña",
  };
  return map[action] || action || "—";
}

onMounted(() => {
  bootstrapModal = new Modal(modalTicketInfo.value);
});

defineExpose({ show, hide });
</script>
